import getMuiTheme from 'material-ui/styles/getMuiTheme';

import spacing from 'material-ui/styles/spacing';

export default getMuiTheme({
    spacing: spacing,
    fontFamily: 'Arial',
    palette: {
        textColor: "#222427",
        primary1Color: "#313639",
        primary2Color: "#d5001c",
        accent1Color: "#313639",
        accent2Color: "#313639",
        accent3Color: "#313639",
        pickerHeaderColor: "#d5001c",
    },
    raisedButton: {
        color: "#313639",
        textColor: "#ffffff",
    },
    flatButton: {
        color: "#313639",
        textColor: "#ffffff",
    },
    textField: {
        textColor: "#222427",
        focusColor: "#d5001c"
    },
    toolbar:
    {
        color: "#ffffff",
        menuHoverColor: "#ffffff",
        hoverColor: "#ff1010"
    },
});



// WEBPACK FOOTER //
// ./src/GlobalTheme.tsx